module.exports = __webpack_public_path__ + "img/49.882a6587.jpg";